const ChromeLeftAlignedTopBarItems = () => null;

export default ChromeLeftAlignedTopBarItems;
